import { COMMENTS_BADGE_Z_INDEX } from '@constants/z-indices';
import { cva } from 'class-variance-authority';

export { baseBlockBodyClasses, blockViewBodyClasses } from '@root/helpers/blocks';

export const leftBorderClasses = cva(
  [
    'transition',
    'duration-500',
    'ease-in-out',
    'absolute',
    'w-1',
    'h-full',
    'left-0',
    'top-0',
    'opacity-0',
    COMMENTS_BADGE_Z_INDEX,
  ],
  {
    variants: {
      editing: { false: null, true: null },
      editable: { true: null, false: null },
      forceHoverEffect: { true: ['bg-info-300!', 'opacity-100'], false: null },
      disableHoverEffect: { true: ['bg-transparent!', 'group-hover:opacity-0!'], false: null },
    },
    compoundVariants: [
      {
        editing: false,
        editable: false,
        className: ['bg-info-300', 'opacity-100'],
      },
      {
        editable: true,
        editing: false,
        className: [
          'group-hover:opacity-100',
          'group-hover:bg-primary-400',
          'group-data-hovered:opacity-100',
          'group-data-hovered:bg-primary-400',
          'bg-transparent',
        ],
      },
      {
        editable: true,
        editing: true,
        className: ['bg-primary-600', 'opacity-100!'],
      },
    ],
  },
);

export const indicatorIconsClasses = [
  'py-3',
  'pr-2',
  'absolute',
  'top-0',
  'right-0',
  'flex',
  'justify-evenly',
  'text-info-500',
  'min-w-mrc-block-padding',
  'bg-transparent',
];
